const alertDialog = {
    namespaced: true,
    mutations: {
        mostrar(state, payload){
            state.titulo=payload.titulo
            state.mensaje=payload.mensaje
            state.botonPrimario=payload.botonPrimario
            state.botonSecundario=payload.botonSecundario
            state.botonTerciario=payload.botonTerciario
            state.callback=payload.callback
        },
        ocultar(state, payload) {
            state.textoAMostrar.mensaje=['']
            state.textoAMostrar.mostrarlo=false
        }
    },
    actions: {
        mostrar(state, payload) {            
            this.commit('alertDialog/mostrar', payload)
        },
        ocultar() {
            this.commit("alertDialog/ocultar")
        }
    }
}

export default alertDialog
